import { SkipButton } from 'components/parts/SkipButton';

import styles from './Screen.module.scss';
type ScreenProps = {
  onNextStep: () => void;
  onSkipDialogue: () => void;
  children: React.ReactNode;
  screen?: 'sky' | 'home' | 'ocean' | 'skyland';
  light?: 'lighting' | 'lightUp' | 'lightDown';
  isSkip?: boolean;
  isBusy?: boolean;
};
export const Screen = ({
  onNextStep,
  onSkipDialogue,
  children,
  screen = 'home',
  light,
  isSkip = true,
  isBusy = false,
}: ScreenProps) => {
  return (
    <>
      {isSkip && !isBusy && (
        <div className={styles.skipButtonRoot}>
          <SkipButton onClick={onSkipDialogue} />
        </div>
      )}
      <button className={styles.fullScreen} type="button" onClick={onNextStep} disabled={isBusy}>
        <div
          className={[styles.background, styles[`--${screen}`], light && styles[`--${light}`]].join(
            ' '
          )}
        ></div>
        {children}
      </button>
    </>
  );
};
